import axios from 'axios'
import security from '@/services/security.js'

export default {
  get (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/course/' + courseKey, config)
      .then(response => {
        return response.data
      })
  },
  update (course) {
    const config = { headers: security.getAuthHeader() }
    return axios.put('/course', course, config)
      .then(response => {
        return response.data
      })
  },
  new (courseSetupInfo, userSetupInfo) {
    const info = {
      CourseName: courseSetupInfo.CourseName,
      HostingCouncil: courseSetupInfo.HostingCouncil,
      CurriculumYear: courseSetupInfo.CurriculumYear,
      DeliveryStyle: courseSetupInfo.DeliveryStyle,
      StaffPrice: courseSetupInfo.StaffPrice,
      ParticipantPrice: courseSetupInfo.ParticipantPrice,
      ParticipatingCouncils: courseSetupInfo.ParticipatingCouncils,
      Session1StartDate: courseSetupInfo.Session1StartDate,
      Session2StartDate: courseSetupInfo.Session2StartDate,
      Location1Name: courseSetupInfo.Location1Name,
      Location2Name: courseSetupInfo.Location2Name,
      ImportFromTemplate: courseSetupInfo.ImportFromTemplate,
      UserName: userSetupInfo.UserName,
      Password: userSetupInfo.Password,
      StaffPositionId: userSetupInfo.StaffPositionId,
      FirstName: userSetupInfo.FirstName,
      LastName: userSetupInfo.LastName,
      ScouterKey: userSetupInfo.ScouterKey
    }

    const config = { headers: security.getAuthHeader() }
    return axios.post('/course', info, config)
      .then(response => {
        return response.data
      })
  },
  getCounts: function (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/course/' + courseKey + '/counts', config)
      .then(response => {
        return response.data
      })
  },
  getCouncilLookups () {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/course/councils', config)
      .then(response => {
        return response.data
      })
  }
}
